import { render, staticRenderFns } from "./UpdateDetailDrawer.vue?vue&type=template&id=15120554&scoped=true"
import script from "./UpdateDetailDrawer.vue?vue&type=script&lang=js"
export * from "./UpdateDetailDrawer.vue?vue&type=script&lang=js"
import style0 from "./UpdateDetailDrawer.vue?vue&type=style&index=0&id=15120554&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15120554",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15120554')) {
      api.createRecord('15120554', component.options)
    } else {
      api.reload('15120554', component.options)
    }
    module.hot.accept("./UpdateDetailDrawer.vue?vue&type=template&id=15120554&scoped=true", function () {
      api.rerender('15120554', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/components/UpdateDetailDrawer.vue"
export default component.exports